import React from 'react';
import { Button, CircularProgress } from '@mui/material';

// Matches the size of a button icon at each button size.
const SPINNER_SIZE = { small: 14, medium: 16, large: 18 };

/**
 * A button that shows it's working: while `busy` it's disabled and a spinner
 * takes the place of its icon, keeping the label so the button doesn't change
 * width. Use it for every action that waits on the server (save, import,
 * export, sign in).
 */
const BusyButton = ({ busy = false, disabled = false, startIcon, size = 'medium', children, ...props }) => (
  <Button
    size={size}
    disabled={busy || disabled}
    startIcon={busy ? <CircularProgress size={SPINNER_SIZE[size]} color="inherit" /> : startIcon}
    {...props}
  >
    {children}
  </Button>
);

export default BusyButton;
